import React, { memo, useCallback } from "react";

// styles
import stylesScss from "../../styles.scss";

// constants
import { NEW_BADGE_LOTTIE_COMPONENT_PROPS, STARS_IMAGE_PROPS } from "../../constants";
import { COUPON_CARD_GROUP_TESTS_IDS } from "@swiggy-private/cart-test-ids";
import { LOCAL_STORAGE_KEYS } from "@core-ui/constants/StorageKeys";
import { COUPON_CARD_GROUP_NEW_LOTTIE_MAXLIMIT } from "@core-ui/constants/Coupon";
import { LOTTIE_ASSETS } from "@core-ui/constants/LottieAssets";

// components
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { ElementObserver } from "@core-ui/components/ElementObserver";
import { LottieAnimation } from "@core-ui/components/lottie-animation";

// utils
import { getCloudinaryRawUrl } from "@swiggy-private/js-utils";
import { LocalStorage } from "@core-ui/helpers/LocalStorage";

export interface TitleTagProps {
    showNewTagLottie?: boolean;
    isRecommendedCouponSection: boolean;
    setShowNewBadgeLottie: (showNewBadgeLottie: boolean) => void;
}

const TitleTag = ({ showNewTagLottie, isRecommendedCouponSection, setShowNewBadgeLottie }: TitleTagProps) => {
    const onViewEnter = useCallback(() => {
        const currentValue = LocalStorage.getItem(LOCAL_STORAGE_KEYS.COUPON_CARD_NEW_BADGE_IMPRESSION_COUNT, 0) || 0;
        const newvalue = currentValue + 1;
        if (newvalue > COUPON_CARD_GROUP_NEW_LOTTIE_MAXLIMIT) {
            setShowNewBadgeLottie(false);
        } else {
            LocalStorage.setItem(LOCAL_STORAGE_KEYS.COUPON_CARD_NEW_BADGE_IMPRESSION_COUNT, newvalue);
        }
    }, [setShowNewBadgeLottie]);

    if (showNewTagLottie) {
        return (
            <ElementObserver onViewEnter={onViewEnter} data-testid={COUPON_CARD_GROUP_TESTS_IDS.NEW_INDICATOR}>
                <LottieAnimation
                    {...NEW_BADGE_LOTTIE_COMPONENT_PROPS}
                    fileName={getCloudinaryRawUrl(LOTTIE_ASSETS.NEW_BADGE_LOTTIE_FILE_ID)}
                    className={stylesScss.lottieContainer}
                    visible={true}
                    playLottie={true}
                />
            </ElementObserver>
        );
    } else if (isRecommendedCouponSection) {
        return <Image {...STARS_IMAGE_PROPS} />;
    }
    return null;
};

export default memo(TitleTag);
